//Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
// Services
import { SessionService } from '../services/SessionService';
import { UserService } from '../services/UserService';
import { RegisterService } from '../services/RegisterService';
//Models
import { Credential } from '../models/Credential';
import { NonAisParent } from '../models/NonAisParent';

@Component({
    selector: 'user-register',
    template: require('./RegisterComponent.html'),
    styles: [require('./RegisterComponent.sass')]
})

export class RegisterComponent implements OnInit {
    message: string;
    selectedTab: number;
    messageType: string;
    redirectUrl: string;
    credential: Credential;
    nonAisParent: NonAisParent;
    formSubmitted: boolean = false;

    constructor(
        private sessionService: SessionService,
        private userService: UserService,
        private registerService: RegisterService,
        private router: Router
    ) {
        
    }

    ngOnInit() {
        this.redirectUrl = '/booking/students';
        this.selectedTab = 1;
        this.nonAisParent = new NonAisParent();
        this.credential = new Credential('parent', '', '');
        // Use Session Service to get session and check if user had already logged in.
        this.getSession();
    }

    onSubmit() {
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.register(this.credential);
    }
    /**
     * Get Session from API service to make sure that user had logged in.
     * Update User Data on local storage and redirect to the desired URL 
     * if request responses session data.
     * @param none
     * @return none
     */
    private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                    this.redirect();
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    private register(credential: Credential) {
        this.registerService.postActivationEmail(credential.role, credential.email)
            .subscribe(
                complete => {
                    this.messageType = "success",
                    this.message = "An activation email had been sent.";
                    this.formSubmitted = false;
                },
                error => {
                    this.messageType = "alert";
                    this.message = "Please input the email you provided to AIS.";
                    this.formSubmitted = false;
                }
            );
    }

    private registerNonAis(nonAisParent: NonAisParent) {
        this.registerService.postNoneAisAccount(nonAisParent)
            .subscribe(
                complete => {
                    this.messageType = "success",
                    this.message = "An activation email had been sent.";
                    this.formSubmitted = false;
                },
                error => {
                    this.messageType = "alert";
                    this.message = "Please input the email you provided to AIS.";
                    this.formSubmitted = false;
                }
            );
    }

    private redirect() {
        // Redirect to stored url
        this.router.navigate([this.redirectUrl]);
    }
 }


// WEBPACK FOOTER //
// ./src/common/modules/user/register/RegisterComponent.ts